import { Input, InputWrapper } from '@recruit-robin/robin-theme/web-components';

import { useDictionary } from '@/shared/lib/i18n';
import { AddressAutocomplete } from '../AddressAutocomplete';
import { FadeIn } from '../FadeIn';
import { InterviewError, InterviewValue } from '../InterviewTypeSelection.types';
import { useStyles } from './InterviewForm.styles';

type InPersonInterviewProps = {
  value: InterviewValue;
  onChange: (value: InterviewValue) => void;
  error?: InterviewError;
};

export const InPersonInterview = ({ value, onChange, error }: InPersonInterviewProps) => {
  const classes = useStyles();
  const dictionary = useDictionary();

  return (
    <FadeIn css={classes.selectionResult}>
      <AddressAutocomplete
        value={value.address ?? ''}
        onChange={(address) => {
          error?.address.reset();
          onChange({ ...value, address });
        }}>
        {({ value, onChange }) => (
          <InputWrapper label={dictionary.address} error={error?.address.error} contained>
            <Input value={value} onChange={onChange} placeholder={dictionary.workAddressPlaceholder} contained />
          </InputWrapper>
        )}
      </AddressAutocomplete>

      <InputWrapper label={dictionary.phone} error={error?.phone.error} contained>
        <Input
          value={value.phone ?? ''}
          onChange={(e) => {
            error?.phone.reset();
            onChange({ ...value, phone: e.target.value });
          }}
          placeholder={dictionary.phonePlaceholder}
          contained
        />
      </InputWrapper>
    </FadeIn>
  );
};
